import { isBudgetCategory } from '@/types/budgets.types'

import type { EditTransactionFormSchema } from '@/components/EditTransactionModal/EditTransactionModal.types'

import {
  category as BudgetCategory,
  type MappedTransaction,
} from '@/__generated__/requests'

export function editTransactionFormDefaultValues(
  transaction: MappedTransaction,
): EditTransactionFormSchema {
  return {
    category: isBudgetCategory(transaction.category)
      ? transaction.category
      : BudgetCategory.OTHER,
    name: transaction.merchant ?? transaction.name,
  }
}
